const ISLIVE = process.env.REACT_APP_IS_LIVE === '1'
const ISDEV = process.env.REACT_APP_IS_DEV === '1'
export const IsPayollEncrypt = process.env.REACT_APP_IS_PAYROLL_ENCRYPTED === '1'

export const BaseUrls: any = {
    
    RECRUITMENT_BASE_URL: {
        url: ISLIVE ? process.env.REACT_APP_API_RECRUITMENT_BASE_URL_LIVE :  ISDEV ? process.env.REACT_APP_API_RECRUITMENT_BASE_URL_DEV :  process.env.REACT_APP_API_RECRUITMENT_BASE_URL_UAT
    },
    ATTENDANCE_BASE_URL :{
        url: ISLIVE ? process.env.REACT_APP_API_ATTENDANCE_BASE_URL_LIVE : ISDEV ? process.env.REACT_APP_API_ATTENDANCE_BASE_URL_DEV : process.env.REACT_APP_API_ATTENDANCE_BASE_URL_UAT
    },
    EMPLOYEE_BASE_URL :{
        url: ISLIVE ? process.env.REACT_APP_API_EMPLOYEE_BASE_URL_LIVE :  ISDEV ? process.env.REACT_APP_API_EMPLOYEE_BASE_URL_DEV :  process.env.REACT_APP_API_EMPLOYEE_BASE_URL_UAT
    },
    PAYROLL_BASE_URL :{
        url: ISLIVE ?  process.env.REACT_APP_API_PAYROLL_BASE_URL_LIVE :   ISDEV ? process.env.REACT_APP_API_PAYROLL_BASE_URL_DEV : process.env.REACT_APP_API_PAYROLL_BASE_URL_UAT 
    },
    HRMS_RECRUITMENT_BASE_URL: {
        url: ISLIVE ? process.env.REACT_APP_API_RECRUITMENT_BASE_URL_LIVE :  ISDEV ? process.env.REACT_APP_API_RECRUITMENT_BASE_URL_DEV : process.env.REACT_APP_API_RECRUITMENT_BASE_URL_UAT
    },
    COMMUNICATION_BASE_URL: {
        url: ISLIVE ? process.env.REACT_APP_API_COMMUNICATION_BASE_URL_LIVE :  ISDEV ? process.env.REACT_APP_API_COMMUNICATION_BASE_URL_DEV : process.env.REACT_APP_API_COMMUNICATION_BASE_URL_UAT
    },
    HRMS_RECRUITMENT_OCR_BASE_URL : {
        url: ISLIVE ? process.env.REACT_APP_API_RECRUITMENT_OCR_BASE_URL_LIVE : ISDEV ? process.env.REACT_APP_API_RECRUITMENT_OCR_BASE_URL_DEV : process.env.REACT_APP_API_RECRUITMENT_OCR_BASE_URL_UAT
    },
    GUEST_EMPLOYEE_BASE_URL :{
        url: ISLIVE ? process.env.REACT_APP_API_EMPLOYEE_BASE_URL_LIVE :  ISDEV ? process.env.REACT_APP_API_EMPLOYEE_BASE_URL_DEV :  process.env.REACT_APP_API_EMPLOYEE_BASE_URL_UAT
    },
    GUEST_RECRUITMENT_BASE_URL: {
        url: ISLIVE ? process.env.REACT_APP_API_RECRUITMENT_BASE_URL_LIVE :  ISDEV ? process.env.REACT_APP_API_RECRUITMENT_BASE_URL_DEV :  process.env.REACT_APP_API_RECRUITMENT_BASE_URL_UAT
    },
    GUEST_HRMS_RECRUITMENT_BASE_URL: {
        url: ISLIVE ? process.env.REACT_APP_API_RECRUITMENT_BASE_URL_LIVE :  ISDEV ? process.env.REACT_APP_API_RECRUITMENT_BASE_URL_DEV : process.env.REACT_APP_API_RECRUITMENT_BASE_URL_UAT
    },
    GUEST_PAYROLL_BASE_URL :{
        url: ISLIVE ?  process.env.REACT_APP_API_PAYROLL_BASE_URL_LIVE :   ISDEV ? process.env.REACT_APP_API_PAYROLL_BASE_URL_DEV : process.env.REACT_APP_API_PAYROLL_BASE_URL_UAT 
    },
    GUEST_COMMUNICATION_BASE_URL: {
        url: ISLIVE ? process.env.REACT_APP_API_COMMUNICATION_BASE_URL_LIVE :  ISDEV ? process.env.REACT_APP_API_COMMUNICATION_BASE_URL_DEV : process.env.REACT_APP_API_COMMUNICATION_BASE_URL_UAT
    },
}   